<template>
    <div class="labelWrapper">
        <button @click="scrollLabels(-1)" :class="{inactive: !allowScrollLeft}">L</button>
        <div class="labelContainer" ref="labelContainer">
            <div class="label" :style="{'--color': '#000'}" :class="{active: !focusClass}" @click.stop="emitFocusClass(null)"> All </div>  
            <div class="label" :style="{'--color': '#000'}" :class="{active: focusClass == -1}" @click.stop="emitFocusClass(-1)"> Unlabeled </div> 
            <template v-for="cls in labels" :key="cls">
                <div class="label" :style="{'--color': cls.color}" :class="{active: focusClass == cls}" @click.stop="emitFocusClass(cls)">
                    {{ cls.name }}
                </div>  
            </template>
        </div>
        <button @click="scrollLabels(1)" :class="{inactive: !allowScrollRight}">R</button>
    </div>
</template>

<script>
export default {
    data(){
        return {
            allowScrollLeft: false,
            allowScrollRight: false
        }
    },
    props: {
        labels: {
            type: Array,
            default: () => []
        },
        focusClass: {
            type: [Object, Number],
            default: null
        }
    },
    methods: {
        emitFocusClass(cls){
            this.$emit('update:focusClass', cls)
        },
        async scrollLabels(value){
            const element = this.$refs.labelContainer
            if (element) {
                const width = element.getBoundingClientRect().width
                const offset = 0.9
                element.scrollBy({ behavior: "smooth", top: 0, left: width * value * offset })
            }
        },
        async refreshScrollable(){
            await this.$nextTick()
            const element = this.$refs.labelContainer
            if (element) {
                this.allowScrollLeft = element.scrollLeft > 0
                this.allowScrollRight = element.scrollLeft + element.clientWidth < element.scrollWidth
            }
        }
    },
    watch: {
        labels:{
            handler() {
                this.refreshScrollable()
            },
            deep: true
        }
    },
    mounted(){
        this.refreshScrollable()
        this.$refs.labelContainer.addEventListener('scroll', this.refreshScrollable)
    },
    beforeUnmount(){
        this.$refs.labelContainer.removeEventListener('scroll', this.refreshScrollable)
    }
}
</script>

<style scoped>

.label{
    min-width: max-content;
    border: 1.5px solid var(--color);
    color: var(--color);
    height: 24px;
    padding: 0 5px;
    display: flex;
    align-items: center;
    cursor: pointer;
}

.label.active, .label:hover{
    background: var(--color);
    color: #fff;
}

.labelWrapper{
    width: 100%; display: flex; gap: 5px;
}

.labelWrapper button{
    width: 24px; height: 24px; background: white;
    border-radius: 5px;
}

.labelContainer{
    flex: 1; display: flex; gap: 5px; overflow-x: auto
}

.labelContainer::-webkit-scrollbar {
    -webkit-appearance: none;
    display: none;
}

button.inactive{
    filter: grayscale(1);
    pointer-events: none;
    background: #eee;
}

button{
    background: #f5e8fe;
    border: 2px solid #8a66c7;
    color: #8a66c7;
    cursor: pointer;

    display: flex;
    align-items: center;
    justify-content: center;
}

button:hover{
    background: #e9d5fb;
}
</style>